import S from 's-js';

import { CachedModelLoader } from 'lib/CachedModelLoader';

import { CoordinationCardVersion, CoordinationCardVersionOptions } from 'data/models/CoordinationCardVersion';

import { PCCache } from 'data/PCCache';

import { PCTabStrip, TitledTab } from 'portcall/pctabstrip/model';

import {
    CoordinationCardDetailsLogTab as LogTabModel,
    CoordinationCardDetailsLogTabParams as LogTabParams
} from './log';
import {
    CancelledCoordinationCardDetailsSettingsTab as SettingsTabModel,
    CancelledCoordinationCardDetailsSettingsTabParams as SettingsTabParams
} from './cancelledsettings';

export const TabLog      : TitledTab = { Title: 'Log'      };
export const TabSettings : TitledTab = { Title: 'Settings' };

export interface CancelledCoordinationCardDetailsParams {
    CoordinationCard : CoordinationCardVersion;
    DismissDetails : () => void;
    ShouldPauseLogUpdates? : () => boolean;
}

export type CancelledCoordinationCardDetails = ReturnType<typeof CancelledCoordinationCardDetails>;
export function CancelledCoordinationCardDetails(
    loader : CachedModelLoader<CoordinationCardVersion, CoordinationCardVersionOptions>,
    data : PCCache,
    logTabModel : (params : LogTabParams) => LogTabModel,
    settingsTabModel : (params : SettingsTabParams) => SettingsTabModel,
    {
        CoordinationCard,
        DismissDetails,
        ShouldPauseLogUpdates
    } : CancelledCoordinationCardDetailsParams
) {
    loader({ Id: CoordinationCard.Id(), ChangeId: CoordinationCard.ChangeId() });
    const
        // Upsert Self ourselves so that it doesn't matter if the server has ever sent us the Self object or
        // not.
        Self = data.CoordinationCardSelves.update1(null, { Id: CoordinationCard.Id() }),
        LogTab = logTabModel({ CoordinationCardSelf: Self }),
        SettingsTab = settingsTabModel({ CoordinationCard }),
        TabStrip = PCTabStrip(TabLog, () => [TabSettings]),
        Loading = () =>
            LogTab.Loading();

    // Turn log updater on/off on various triggers...
    S(() => {
        // Basic logic -- run log updates as long as we're on the log tab, or we can get a head start if we
        // know we're flipping to the log tab...
        const
            tabState = TabStrip.State(),
            // CAUTION: The log tab is our FRONT tab here, unlike some other spots where we do similar logic
            // for log updates.
            onOrApproachingLogTab =
                tabState.state === 'settled-on-front' ||
                tabState.state === 'flipping-to-front',
            // ...but also give calling code a say in whether we should be running log updates.
            shouldRunLogUpdates = onOrApproachingLogTab && !ShouldPauseLogUpdates?.();

        if (shouldRunLogUpdates) LogTab.LogUpdater.start();
        else LogTab.LogUpdater.stop();
    });

    return {
        DismissDetails,
        LogTab,
        SettingsTab,
        TabStrip,
        Loading
    };
}



// WEBPACK FOOTER //
// ./apps/portcall/coordinationcarddetails/cancelled.ts